import { SVGProps } from 'react';

const SvgPerson = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M112 48a48 48 0 1 1 96 0 48 48 0 1 1-96 0zm32 128.1V304h32V176.1c-.7 0-1.5-.1-2.3-.1h-27.4c-.8 0-1.5 0-2.3.1zm0 175.9v136c0 13.3-10.7 24-24 24s-24-10.7-24-24V223.6l-43.1 76.2c-6.5 11.5-21.2 15.6-32.7 9.1s-15.6-21.2-9.1-32.7l58.6-103.5c15.6-27.6 44.9-44.7 76.6-44.7h27.5c31.7 0 61 17.1 76.6 44.7l58.5 103.5c6.5 11.5 2.5 26.2-9.1 32.7s-26.2 2.5-32.7-9.1L224 223.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V352h-32z" />
  </svg>
);
export default SvgPerson;
